import type {Query, QueryConstraint, QueryDocumentSnapshot} from 'firebase/firestore';
import {ContactMessageState, type ContactMessage} from '@cp/model';
import {endBefore, limit as limitFirestore, orderBy, query, startAfter, where} from 'firebase/firestore';
import getContactMessageCollection from './getContactMessageCollection';

export interface ListContactMessageDocOptions {
  limit: number;
  includeArchived?: boolean;
  includeRead?: boolean;
  includeUnread?: boolean;
}

export type ListContactMessageDocCursor =
  | {startAfter: QueryDocumentSnapshot<ContactMessage>}
  | {endBefore: QueryDocumentSnapshot<ContactMessage>}
  | null;

export default function listContactMessageDoc(
  options: ListContactMessageDocOptions,
  cursor: ListContactMessageDocCursor,
): Query<ContactMessage> {
  const {limit, includeArchived = false, includeRead = true, includeUnread = true} = options;
  const states: ContactMessageState[] = [];
  if (includeUnread) states.push(ContactMessageState.UNREAD);
  if (includeRead) states.push(ContactMessageState.READ);
  if (includeArchived) states.push(ContactMessageState.ARCHIVE);

  const constraints: QueryConstraint[] = [
    orderBy('createdAt', 'desc'),
    ...(cursor && 'startAfter' in cursor ? [startAfter(cursor.startAfter)] : []),
    ...(cursor && 'endBefore' in cursor ? [endBefore(cursor.endBefore)] : []),
    ...(states.length > 0 ? [where('state', 'in', states)] : []),
    limitFirestore(limit),
  ];
  return query(getContactMessageCollection(), ...constraints) as Query<ContactMessage>;
}
